import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Services
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class InitAppService {

  // Objetos Observable y Emiters
  private showMenuMobile$ = new Subject<string>();

  constructor(
    private _httpService: HttpService
  ) { }

  // Actualizar logo del header
  emmiterUpdateBrandLogo(val: string): void {
    this.showMenuMobile$.next(val);
  }
  
  getSubjetUpdateBrandLogo(): Subject<string> {
    return this.showMenuMobile$;
  }
  
  // Functions HTTP
  getDataInitial(id: any) {
    let headers: any = {
      'dataEmpresa': 'true'
    }
    return this._httpService.httpGet(`ecommerce/empresa/${id}`, headers);
  }
  
}
